module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "disport-header"
  }, [_c('a-swipe'), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "hot-disport"
  }, [_c('img', {
    staticClass: "hot-top",
    attrs: {
      "src": require("../assets/img/top100.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disport-content"
  }, _vm._l((_vm.disportList), function(item) {
    return _c('div', {
      staticClass: "disport-item col-xs-6 fl",
      on: {
        "click": function($event) {
          _vm.disportPlay(item.aid, item.title, item.author)
        }
      }
    }, [_c('img', {
      staticClass: "disport-img",
      attrs: {
        "src": item.pic,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "disport-info"
    }, [_c('span', {
      staticClass: "disport-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "disport-user"
    }, [_c('span', {
      staticClass: "disport-author"
    }, [_vm._v(_vm._s(item.author))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" "), _c('p', {
      staticClass: "disport-num fr"
    }, [_vm._v(_vm._s(item.play))])])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "disport-nav"
  }, [_c('li', [_vm._v("生活娱乐")]), _vm._v(" "), _c('li', [_vm._v("鬼畜调教")]), _vm._v(" "), _c('li', [_vm._v("萌宠")]), _vm._v(" "), _c('li', [_vm._v("美食")]), _vm._v(" "), _c('li', [_vm._v("综艺")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70a733c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/disport.vue
// module id = 110
// module chunks = 0